import { useContext } from 'react';

import { Box, List, Typography } from '@mui/material';

import NavItem from './NavItem';
import { MenuContext } from 'layout/MainLayout';
import type { MenuGroup } from 'menu-items/types';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

interface NavGroupProps {
    item: MenuGroup;
}

const NavGroup = ({ item }: NavGroupProps) => {
    const { isDrawerOpen } = useContext(MenuContext);

    const navCollapse = item.children?.map((menuItem) => {
        switch (menuItem.type) {
            case 'collapse':
                return (
                    <Typography key={menuItem.id} variant="caption" color="error" sx={{ p: 2.5 }}>
                        collapse - only available in paid version
                    </Typography>
                );
            case 'item':
                return <NavItem key={menuItem.id} item={menuItem} level={1} />;
            default:
                return (
                    <Typography key={menuItem.id} variant="h6" color="error" align="center">
                        Fix - Group Collapse or Items
                    </Typography>
                );
        }
    });

    return (
        <List
            subheader={
                item.title &&
                isDrawerOpen && (
                    <Box sx={{ pl: 3, mb: 1.5 }}>
                        <Typography variant="caption" color="textSecondary">
                            {item.title}
                        </Typography>
                    </Box>
                )
            }
            sx={{ mb: isDrawerOpen ? 1.5 : 0, py: 0, zIndex: 0 }}
        >
            {navCollapse}
        </List>
    );
};

export default NavGroup;
